/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Helmet } from 'react-helmet';

function PageMeta({
    title = null,
    image = null,
}: {
    title?: string | null;
    image?: string | null;
}) {
    return (
        <Helmet>
            {title !== null ? <title>{title}</title> : null}
            {image !== null ? <meta property="og:image" content={image} /> : null}
        </Helmet>
    );
}

export default PageMeta;
